var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonSecondRightTopreact = function SvgButtonSecondRightTopreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 148.725 147.101"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1548",
    transform: "translate(-2689.845 -152.194)",
    fill: "#fa6e00"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 32",
    cx: 55.789,
    cy: 24.262,
    rx: 55.789,
    ry: 24.262,
    transform: "rotate(-40 1720.34 -3607.07)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 33",
    cx: 55.789,
    cy: 15.526,
    rx: 55.789,
    ry: 15.526,
    transform: "rotate(-40 1678.396 -3591.801)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 34",
    cx: 55.789,
    cy: 9.923,
    rx: 55.789,
    ry: 9.923,
    transform: "rotate(-40 1651.843 -3582.137)"
  }))));
};

export default SvgButtonSecondRightTopreact;